export default __webpack_public_path__ + "static/media/FB_green.9bdcf164.svg";